<template>
    <div
        v-if="isCustomizedContactRecord"
    >
        <div class="record">
            <div class="record-avatar">
                <ds-icon-button
                    name="arrow-left"
                    data-qa="back-button"
                    @click="back"
                />

                <ds-avatar
                    :email="contact.email"
                    data-qa="profile-image"
                    :name="fullName"
                    :size="120"
                />
            </div>

            <div class="tabs">
                <div class="contact-record-info-name">
                    <h2 data-qa="contact-record-info-name">
                        {{ fullName }}
                    </h2>

                    <div v-if="isFeatureFlag33491Enabled" class="manage-layout-dropdown">
                        <ds-dropdown class="dropdown" position="bottom-start" close-on-menu-click>
                            <ds-outline-button class="add-contact-title tab-selected">
                                <span>{{ layoutName }}</span>

                                <ds-icon class="chevron" name="chevron-down" />
                            </ds-outline-button>

                            <div slot="menu">
                                <ul class="dropdown-menu-list">
                                    <li
                                        v-for="(layout, i) in contactLayoutsList"
                                        :key="i"
                                        :class="['dropdown-menu-item', { selected: layoutId === layout.id }]"
                                        @click="getlayout(layout)"
                                    >
                                        <span>
                                            <ds-icon style="margin-right: 16px" name="business-card" />
                                        </span>
                                        {{ layout.name }}
                                    </li>
                                </ul>
                            </div>

                            <div
                                slot="footer"
                                class="drop-footer"
                                data-qa="manage-layout"
                                @click="manageLayout"
                            >
                                Manage layouts
                            </div>
                        </ds-dropdown>
                    </div>
                </div>

                <contact-header :id="contact.id.toString()" :meta-data="metaData" />

                <contact-tab :meta-data="metaData" :contact="contact" />

                <contact-footer :contact="contact" />
            </div>
        </div>

        <ds-focus-on-keyboard-only />
    </div>

    <div v-else>
        <contact-layout :layout-id="layoutId" :user-id="metaData.userId.toString()" :show-campaign-stealth-tab="showCampaignStealthTab" />
    </div>
</template>

<script scoped>
import axios from 'axios';
import ContactHeader from './ContactHeader';
import ContactTab from './ContactTab';
import ContactFooter from './ContactFooter';
import ContactLayout from './layout/ContactLayout';

export default {
    components: {
        ContactHeader,
        ContactTab,
        ContactFooter,
        ContactLayout,
    },

    props: {
        contact: Object,
        metaData: Object,
    },

    data() {
        return {
            isCustomizedContactRecord: true,
            layoutId: 0,
            contactLayoutsList: [],
            layoutName: '',
            isFeatureFlag33491Enabled: false,
            isFeatureFlag49511Enabled: false,
            selected: false,
            showCampaignStealthTab: false,
        };
    },

    created() {
        this.showCampaignStealthTab = Boolean(this.metaData?.isContactTabCampaignStealthEnable);
        this.getContactLayoutList();
        this.isFeatureFlag49511Enabled = this.metaData.isFeatureFlag49511Enabled;
        this.loadLayout();
        this.isFeatureFlag33491Enabled = this.metaData.isFeatureFlag33491Enabled;
    },

    mounted() {
        this.$root.$on('BACK_BUTTON', (actionItem) => {
            if (actionItem) {
                this.getBackUrl();
            }
        });

        this.$root.$on('CUSTOMIZED_CONTACT_RECORD', this.getCustomizedContactRecord);
        this.$root.$on('CUSTOMIZED_CONTACT_RECORD_LAYOUT_DETAILS', (data) => {
            this.layoutId = Number(data.layoutId);
            this.getCustomizedContactRecord(data.actionItem);
            this.getContactLayoutList();
        });
    },

    beforeDestroy() {
        this.$root.$off('BACK_BUTTON');
        this.$root.$off('CUSTOMIZED_CONTACT_RECORD', this.getCustomizedContactRecord);
        this.$root.$off('CUSTOMIZED_CONTACT_RECORD_LAYOUT_DETAILS');
    },

    computed: {
        fullName() {
            return `${this.contact.firstName} ${this.contact.middleName || ''} ${this.contact.lastName}`;
        },
    },

    methods: {
        getCustomizedContactRecord(actionItem) {
            this.isCustomizedContactRecord = !actionItem;
        },

        back() {
            window.history.back();
        },

        close() {
            this.$root.$emit('OPEN_CONFIRM_MODAL_BACK_BUTTON', 'CLOSE_BUTTON');
        },

        getBackUrl() {
            window.location.href = this.metaData.backUrl;
        },

        manageLayout() {
            if (this.isCustomizedContactRecord) {
                this.$root.$emit('DISABLE_SWAP_IN_CUSTOMIZED_CONTACT_RECORD', true);
            }
            this.$root.$emit('CUSTOMIZED_CONTACT_RECORD', true);
        },

        getlayoutName() {
            this.contactLayoutsList && this.contactLayoutsList.map((layout) => {
                if (layout.id === this.layoutId) {
                    this.layoutName = layout.name;
                    this.$root.$emit('LAYOUTID_TAB', layout);
                }

                return this.layoutName;
            });
        },

        async getContactLayoutList() {
            const userId = this.metaData.userId.toString();

            try {
                const response = await axios.get(`/app/contactLayout?userId=${userId}`);

                this.contactLayoutsList = response.data;
                this.getlayoutName();
            } catch (e) {
                this.$error({ message: 'Unable to get all layouts' });
            }
        },

        async getlayout(layout) {
            if (this.isFeatureFlag49511Enabled) {
                await axios.post(`/app/contact/selectedLayout?layoutId=${layout.id}`);
            }
            this.layoutName = layout.name;
            this.layoutId = layout.id;
            this.$root.$emit('LAYOUTID_TAB', layout);
            this.selected = true;
        },

        loadLayout() {
            if (this.isFeatureFlag49511Enabled && Number(this.metaData.selectedLayout) !== Number(this.metaData.defaultLayoutId)) {
                this.layoutId = Number(this.metaData.selectedLayout);
            } else {
                this.layoutId = Number(this.metaData.defaultLayoutId);
            }
        },

    },
};
</script>

<style lang="scss" scoped>
.record {
    display: flex;
}

.drop-footer {
    height: 1.5rem;
    text-align: center;
    color: $color-blue;
    cursor: pointer;
}

.chevron {
    --icon-size: 1.3rem;
    margin-left: $spacing-200;
}

.record-avatar {
    display: flex;
    align-items: flex-start;
}

.tabs {
    width: 100%;
    flex-direction: column;
    border-bottom: none;
    margin-top: 0;
}

.add-contact-title {
    display: flex;
    align-items: center;
}

@media screen and ($small) {
    .record-avatar {
        display: flex;
        margin-left: auto;
        margin-right: auto;
    }

    .record {
        display: block;
    }
}

textarea:focus,
input:focus,
button:focus {
    outline: none;
}

.contact-record-info-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: $spacing-100;
}

.dropdown-menu-list {
    padding: 0.75rem 0;
    color: $color-black;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
}

.dropdown-menu-list::-webkit-scrollbar {
    display: none;
}

.dropdown-menu-list {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

@media screen and ($small) {
    .contact-record-info-name {
        display: block;
    }

    .manage-layout-dropdown {
        .dropdown {
            margin-top: $spacing-200;
        }
    }
}
</style>
